module.exports = __webpack_public_path__ + "static/media/no-select-stamp.139d7dd8.png";